module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-132220133-1"],"pluginConfig":{"head":true,"respectDNT":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-132220133-1","head":false,"respectDNT":true,"defer":true,"sampleRate":5,"siteSpeedSampleRate":10,"cookieDomain":"gemini-is.com","anonymize":false,"exclude":[],"pageTransitionDelay":0,"enableWebVitalsTracking":false},
    }]
